module.exports = __webpack_public_path__ + "static/media/video_fachada-polanco.7ed3391d.mp4";